
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  display: flex;
  flex-wrap: wrap;
}
:host .content-notification-holder {
  display: flex;
  width: 100%;
  border-radius: 16px;
  padding: 8px;
}
:host .content-notification-holder.info {
  background-color: var(--slh-color-info-shade-20, #E3F1FF);
  border: 1px solid var(--slh-color-info-shade-80, #90C7FF);
}
:host .content-notification-holder.info slh-icon.alert-icon {
  fill: var(--slh-color-info, #74B9FF);
}
:host .content-notification-holder.success {
  background-color: var(--slh-color-success-shade-20, #CCF1EA);
  border: 1px solid var(--slh-color-success-shade-80, #33C6A9);
}
:host .content-notification-holder.success slh-icon.alert-icon {
  fill: var(--slh-color-success, #00B894);
}
:host .content-notification-holder.warning {
  background-color: var(--slh-color-warning-shade-20, #FFF5E2);
  border: 1px solid var(--slh-color-warning-shade-80, #FED58B);
}
:host .content-notification-holder.warning slh-icon.alert-icon {
  fill: var(--slh-color-warning, #FDCB6E);
}
:host .content-notification-holder.error {
  background-color: var(--slh-color-error-shade-20, #FFEDEB);
  border: 1px solid var(--slh-color-error-shade-80, #FFA399);
}
:host .content-notification-holder.error slh-icon.alert-icon {
  fill: var(--slh-color-error, #FF7E70);
}
:host .content-notification-holder slh-icon.alert-icon {
  margin-top: 12px;
  margin-right: 16px;
  margin-left: 8px;
  flex: 1 0 auto;
}
:host .content-notification-holder slot[name=close-icon] {
  margin-left: 16px;
  fill: var(--slh-color-neutral-shade-60, #62779F);
  cursor: pointer;
  flex: 1 0 auto;
  display: flex;
}
:host .content-notification-holder .content-notification {
  flex: 1 1 100%;
}
:host .content-notification-holder .content-notification slot {
  display: block;
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
}
:host .content-notification-holder .content-notification slot, :host .content-notification-holder .content-notification slot::slotted(*) {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xs-font-size, 14px);
  line-height: var(--slh-base-xxs-line-height, 24px);
}
:host .content-notification-holder .content-notification slot[name=title] {
  font-weight: var(--slh-base-bold-font-weight, 700);
  color: var(--slh-color-neutral, #39455D);
}
:host .content-notification-holder.one-column {
  flex-wrap: wrap;
  justify-content: space-between;
}
:host .content-notification-holder.one-column slh-icon.alert-icon {
  order: 1;
  flex: none;
  margin-top: 0;
}
:host .content-notification-holder.one-column slot[name=close-icon] {
  order: 2;
  flex: none;
}
:host .content-notification-holder.one-column .content-notification {
  order: 3;
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 8px;
}

:host(.content-notification-closed) {
  display: none;
}

:host(:focus) {
  outline: none;
}

@media only screen and (max-width: 560px) {
  :host .content-notification-holder {
    flex-wrap: wrap;
    justify-content: space-between;
  }
  :host .content-notification-holder slh-icon.alert-icon {
    order: 1;
    flex: none;
    margin-top: 0;
  }
  :host .content-notification-holder slot[name=close-icon] {
    order: 2;
    flex: none;
  }
  :host .content-notification-holder .content-notification {
    order: 3;
    padding-left: 8px;
    padding-right: 8px;
    margin-top: 8px;
  }
}
`;
